import React, { useEffect, createElement } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { TrustBadges } from './components/TrustBadges';
import { PainPoints } from './components/PainPoints';
import { ChaptersAccordion } from './components/ChaptersAccordion';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { BuySection } from './components/BuySection';
import { Objections } from './components/Objections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const pixelId = '1252242806993118';
    const w = window as any;
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(t, firstScript);
      } else {
        document.head.appendChild(t);
      }
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      // Cleanup if necessary
      if (document.head.contains(noscript)) {
        document.head.removeChild(noscript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-blue-200 selection:text-blue-900" data-id="element-0">
      <CountdownBar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBadges data-id="element-4" />
        <PainPoints data-id="element-5" />
        <ChaptersAccordion data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Bonuses data-id="element-8" />
        <BuySection data-id="element-9" />
        <Objections data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
      <SocialProofPopup data-id="element-12" />
    </div>;
}